import React from "react";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Box, SvgIconProps, Typography } from "@mui/material";

import { ButtonVariant } from "Constant/button";

import StandartButton from "components/atoms/StandartButton";

interface EmptyStateProps {
    noBorder?: boolean;
    icon?: React.ReactElement<SvgIconProps>;
    title: string;
    description: string;
    actionLabel?: string;
    onAction?: () => void;
    actionDisabled?: boolean;
    actionIcon?: React.ReactElement<SvgIconProps>;
    compact?: boolean;
    hideText?: boolean;
    flush?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
    noBorder = false,
    icon,
    title,
    description,
    actionLabel,
    onAction,
    actionDisabled = false,
    actionIcon = <AddRoundedIcon />,
    compact = false,
    hideText = false,
    flush = false,
}) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                px: compact ? 2 : 3,
                py: compact ? 3 : 5,
                width: "100%",
                height: compact ? "auto" : "100%",
                flex: compact ? "0 0 auto" : 1,
                minHeight: compact ? 0 : 360,
                boxSizing: "border-box",
                ...(flush
                    ? {}
                    : {
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                          border: noBorder
                              ? "none"
                              : "1px solid rgba(0, 0, 0, 0.05)",
                          boxShadow: "none",
                      }),
            }}
        >
            {icon && (
                <Box
                    sx={{
                        width: compact ? 40 : 56,
                        height: compact ? 40 : 56,
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: compact ? 1.25 : 2,
                        backgroundColor: "#f2f2f5",
                        border: "1px solid #e5e5ea",
                        "& .MuiSvgIcon-root": {
                            fontSize: compact ? 20 : 28,
                            color: "#ed6c02",
                        },
                    }}
                    aria-hidden
                >
                    {icon}
                </Box>
            )}
            {!hideText && (
                <>
                    <Typography
                        sx={{
                            fontWeight: 700,
                            fontSize: compact ? "14px" : "16px",
                            color: "#1a1a1a",
                            fontFamily: '"Nunito", sans-serif',
                            mb: 0.75,
                        }}
                    >
                        {title}
                    </Typography>
                    <p
                        className="empty-state-description"
                        style={{
                            fontSize: compact ? 13 : 14,
                            color: "#000000",
                            WebkitTextFillColor: "#000000",
                            opacity: 1,
                            maxWidth: compact ? 280 : 320,
                            marginTop: 0,
                            marginBottom:
                                actionLabel && onAction
                                    ? compact
                                        ? 14
                                        : 20
                                    : 0,
                            lineHeight: 1.5,
                            fontFamily: '"Nunito", sans-serif',
                        }}
                    >
                        {description}
                    </p>
                </>
            )}
            {actionLabel && onAction && (
                <StandartButton
                    variant={ButtonVariant.BLACK_OUTLINED}
                    startIcon={actionIcon}
                    onClick={onAction}
                    disabled={actionDisabled}
                >
                    {actionLabel}
                </StandartButton>
            )}
        </Box>
    );
};

export default EmptyState;
